// extracted by mini-css-extract-plugin
export default {"wrapper":"Actions_wrapper__RUyP5","toggle":"Actions_toggle__8RkQD","toggle__label":"Actions_toggle__label__GpD4X","toggle__label_active":"Actions_toggle__label_active__BLmd7"};